import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const InsightsSwiperContainer = styled(Box)`
  display: flex;
  justify-content: stretch;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  width: 100%;

  .swiper {
    width: 100%;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    min-height: 200px;
    height: auto;
    width: auto;
  }
`;

export const InsightItem = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${(p) => p.theme.colors.background2};
  border-radius: 0.5rem;
  width: 100%;
  max-width: 320px;
  /* min-width: 220px; */

  &[aria-disabled="true"] {
    opacity: 0.6;
  }
`;
